import * as React from 'react';
import { AppState } from '../store'
import { Bar } from 'react-chartjs-2';

interface OwnProps {}

type AppProps = OwnProps & AppState;

const legend = {
    label: '凡例',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    borderColor: 'rgba(255,0,0,1)',
    borderWidth: 2,
    data: [0, 800, 1500],
    yAxisID: "legend"
};

const colors = ['rgba(255,99,132,0.2)', 'rgba(99,255,132,0.2)', 'rgba(132,99,255,0.2)']

const createDataSet = (props: AppProps) => {
    const data = {
        labels: ['カロリー', 'リン', 'カリウム'],
        datasets:
            props.items.filter(i => i.selecetd).map((i, n) => {
                return {
                    label: i.name,
                    backgroundColor: colors[n % colors.length],
                    borderColor: 'rgba(255,255,255,0)',
                    borderWidth: 1,
                    data: [i.nutrients[1].value, i.nutrients[8].value, i.nutrients[6].value],
                    yAxisID: "y-axis-1",
                };
            }).concat(legend),
    };
    return data;
}

// const createOptions = (props: AppProps) => {
//     return options;
// };
const options = {
    scales: {
        xAxes: [{stacked: true}],
        yAxes: [{
            id: "y-axis-1",
            stacked: true,
            ticks: {
                max: 2000,
            }
        },{
            id: "legend",
            display: false,
            position: "right",
            ticks: {
                max: 2000,
            }
        }],
    }
}

export const ChartComponent: React.SFC<AppProps> = (props: AppProps) => {
  return (
      <div className="chart">
        <Bar data={createDataSet(props)} options={options} />
      </div>
  );
};
